import { ActionIcon, DragNDrop, InfoBox, Loader } from "@tfg/ui"
import { useState } from "react"

import { useFindAllProductPageComponents } from "~/gen/api"
import { useOrganizationSettings } from "~/pages/Brand/OrganizationSettings/store/organization-settings-context"

import { EditProductComponentModal } from "./EditProductComponentModal"

import { Content } from "./index"

export const PageComponentsEditor = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedComponent, setSelectedComponent] = useState<{
    productPageComponentId: string
    content: Content
  } | null>(null)
  const { displaySettingsId } = useOrganizationSettings()
  const { data, isLoading } = useFindAllProductPageComponents({
    displaySettingsId: displaySettingsId ?? "",
  })

  if (isLoading) {
    return <Loader />
  }

  const pageComponents = data?.data
    .sort((a, b) => a.order - b.order)
    .map((component) => ({
      id: component.id,
      label: component.componentType,
      position: component.order,
      cta:
        Object.keys(component.content || {}).length > 0 ? (
          <ActionIcon
            type="edit"
            onClick={() => {
              setIsModalOpen(true)
              setSelectedComponent({
                productPageComponentId: component.id,
                content: component.content,
              })
            }}
          />
        ) : null,
    }))

  return (
    <>
      {pageComponents && pageComponents.length > 0 ? (
        <DragNDrop data={pageComponents} />
      ) : (
        <InfoBox
          title="No components found"
          message="Please add a component to the product sheet"
        />
      )}
      {selectedComponent && isModalOpen && (
        <EditProductComponentModal
          selectedComponent={selectedComponent}
          onClose={() => setIsModalOpen(false)}
          isOpen={isModalOpen}
        />
      )}
    </>
  )
}
